import Description from "./Description";
import Social from "./Social";

export default {
  Description,
  Social
};
